import {
  NPVR_GET_RECORDING_LIST,
  NPVR_GET_RECORDING_LIST_CLEAR,
  NPVR_GET_RECORDING_LIST_ERROR,
} from 'containers/Player/actions/recording/constants';

const initialState = {
  loading: false,
  channels: null,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NPVR_GET_RECORDING_LIST:
      return {
        ...state,
        channels: action.payload,
        loading: false,
        error: false,
      };
    case NPVR_GET_RECORDING_LIST_ERROR:
      return { ...state, channels: null, error: action.payload };
    case NPVR_GET_RECORDING_LIST_CLEAR:
      return initialState;
    default:
      return state;
  }
};
